import { mapGetters, mapMutations } from 'vuex';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import SplitTreatments from '@/common/components/split/SplitTreatments.vue';

export default {
    name: 'dppPhoto',
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
        mvtHotleadForm,
        SplitTreatments,
    },
    data() {
        return {
            imageIndex: null,
            cateIndex: null,
            photoIndex: null,
            isMounted: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'viewport', 'getSplit', 'hasAgent']),
        ...mapGetters('dpp', ['dpp', 'getCategories', 'getPhotos', 'getImageIndex']),
        markers() {
            return [{ lat: this.dpp.geo.lat, lng: this.dpp.geo.lng, type: this.dpp.propertyType }];
        },
        gethotleadSub() {
            if (!this.dpp.isActive) {
                let area = this.dpp.geo.neighborhoodName || this.dpp.geo.zipcode;
                return `Our agents specialize in selling homes in ${area}`;
            } else if (this.dpp.isActive && !this.dpp.isRentals) {
                return 'We will connect you with a top local agent'
            }
            return this.dpp.isPrOnly || !this.dpp.isRentals ? 'We can help you find similar homes in the area.' : undefined;
        },
        testRequestTour() {
            return this.dpp.isActive;
        },
        hotleadOpt() {
            return {
                enableChangeDate: this.testRequestTour || undefined,
                date: !this.testRequestTour ? new Date() : undefined,
                optionalDate: this.testRequestTour ? true : false,
                hotleadTitle: this.testRequestTour ? this.molang('dpp.hotButton.requestTour') : !this.dpp.isActive ? 'Connect with a local selling agent' : undefined,
                hotleadSub: this.testRequestTour ? this.molang('dpp.propertySchedule.seeThisHome') : this.gethotleadSub,
                hotleadType: this.testRequestTour ? 'TourOnHeroPhoto' : !this.dpp.isActive ? 'OffMarketCombinationSell' : 'All_Photos_Bottom_Active',
                trigger: this.testRequestTour ? 'propertyTour' : undefined,
                propertyId: this.dpp.propertyId,
                hideProfile: true,
                propertyData: this.dpp,
                showComment: false,
                showConcierge: true,
                buttonText: this.testRequestTour ? this.molang('dpp.hotleadForm.submit') : !this.dpp.isActive ? 'Connect' : undefined,
            };
        },
        isHeroStreetView() {
            return this.dpp.photoCount === 0 && !!this.glb.welcomeImage;
        },
        getStreetAndMapImages() {
            return [
                {
                    type: 'streetview',
                    fallback: 'roadmap',
                    placeholder: this.dpp.photoCount === 0 ? this.glb.welcomeImage : '',
                    eager: this.isHeroStreetView,
                    show: this.showStreetImage,
                },
                {
                    type: 'satellite',
                    show: this.showMapImage,
                },
                {
                    type: 'terrain',
                    show: this.showMapImage,
                },
            ];
        },
        showStreetImage() {
            return this.getPhotos.length < 4;
        },
        showMapImage() {
            return this.getPhotos.length < 3;
        },
        getPhotosCount() {
            const photos = this.getPhotos;
            return (photos && photos.length) || 0;
        },
    },
    watch: {
        getImageIndex(newval) {
            var item = this.$refs.list.querySelector('[data-index="' + newval + '"]');
            if (item) {
                item.scrollIntoView(true);
            }
        },
    },
    methods: {
        ...mapMutations('dpp', ['updateMapUrls']),
        ...mapGetters('glb', ['getComplianceMethod']),
        showWatermark() {
            const compliance = this.getComplianceMethod()();
            return compliance[0]?.rule.indexOf('showMlsWatermarkOnViewArea') >= 0;
        },
        refreshMap() {
            if (this.$refs.map && this.$refs.map.length > 0) {
                this.$refs.map.forEach((e) => {
                    e.loadMapSrc(this.dpp.geo.formatAddress, this.dpp.geo.lat, this.dpp.geo.lng, this.markers);
                });
            }
        },
        openHotlead(buttonText) {
            this.$eventBus.$emit('property-pop-schedule', {
                date: new Date(),
                hotleadType: 'SwipePastPhotosRequestTour',
                hotleadTitle: this.testRequestTour ? this.molang('dpp.hotButton.requestTour') : this.molang('dpp.hotButton.requestaTour'),
                changeDate: true,
                trigger: this.testRequestTour ? 'propertyTour' : this.$options.name,
                buttonText: this.testRequestTour ? this.molang('dpp.hotleadForm.submit') : buttonText,
                hideProfile: this.testRequestTour,
                showAddressAndImage: this.testRequestTour,
                hotleadSub: this.testRequestTour ? this.molang('dpp.propertySchedule.seeThisHome') : '',
            });
        },
        getUrl(urls) {
            if (urls && urls.src) {
                this.updateMapUrls(urls);
            }
        },
        group(array, number) {
            var group = [[]];
            group = array.reduce(function (prev, next, i) {
                var last = prev[prev.length - 1];
                if (last.length < number) {
                    last.push(next);
                } else {
                    prev.push([next]);
                }
                return prev;
            }, group);
            return group;
        },
        forceLoadMaps() {
            const maps = this.$refs.map;
            if (maps) {
                const list = Array.isArray(maps) ? maps : [maps];
                list.forEach((m) => m.forceLoad());
            }
        },
        openPhotoView(cateIndex, photoIndex, i) {
            if (this.dpp.hidePhotosByCompliance) {
                this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin' }, trigger: this.$options.name });
                return;
            }
            this.forceLoadMaps();
            this.$eventBus.$emit('property-pop-photo', { cateIndex: cateIndex, photoIndex: photoIndex, single: !this.glb.isPhone });
        },
        popMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: false });
        },
        popSatelliteMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 1, popStreetView: false });
        },
        popStreetView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: true });
        },
        getZoom(imageType) {
            return imageType == 'satellite' ? 18 : '';
        },
    },
    mounted() {
        this.isMounted = true;
    },
};
